<template>
  <div class="contact-footer">
    <span class="contact-prefix"><slot /></span>
    <a class="contact-link" :href="contactUrl">
      <span class="contact-label">LinkedIn</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="1949.333" height="1949.333" viewBox="0 0 1462 1462"><path fill="currentColor" d="M707 2.2C580.2 5.6 452.5 44.7 343.5 113.3c-32.1 20.2-66.7 46.2-95.4 71.5-15.4 13.6-46.4 44.5-60.9 60.7C83.9 361 19.9 506.6 5 660 1.8 693.3.9 747.5 3 778.5c12.3 179.4 86.4 343 212.5 469 93.2 93.2 207.7 158.7 334.5 191.4 60.1 15.5 115.7 22.4 180.5 22.4 47.3.1 80.4-2.6 123.2-9.8 146.8-25 280.7-93.2 388.2-198 56.2-54.8 104.8-121 141.1-192 90.7-177.9 103.7-389.4 35.5-577.5-18.2-50.2-43-100.6-71.6-145.2-47.6-74.6-108.4-139.7-179.9-193C1053.3 61.1 917.7 11.5 777 3c-23.9-1.4-41.1-1.6-70-.8zm81.5 65.2c67.8 6.1 131.4 21.2 192.1 45.7 85.6 34.5 159.5 83.7 224.6 149.5 20.8 21 30.6 32 47.7 53.4 76.3 95.2 125.3 211.2 140 331.5 4.2 34.2 4.6 41.4 4.6 84.5-.1 45.5-.9 58.9-6.1 95-27.8 194.4-140.2 366.6-307.4 470.7-88.5 55.1-183.7 87.1-292 98-22.2 2.2-95.1 2.5-115.5.5-33.1-3.3-57.3-6.9-81-11.8-114.4-23.9-218-76-306.5-154.1-14.7-12.9-46.2-44.5-58.6-58.8-88.8-101.9-144-225.2-160.3-358-3.7-30-4.6-45.5-4.5-82 0-36.4.8-50.7 4.5-81.5 15.7-130.9 69.6-252.2 157.5-355 12.6-14.8 52.6-54.8 67.4-67.4 95.2-81.4 205.1-133.1 326.5-153.5 22.8-3.9 44.9-6.2 80.5-8.5 12.4-.8 70.7.4 86.5 1.8z"/><path fill="currentColor" d="M429.3 320.4c-39 7.5-69.4 37.7-76.9 76.4-2 10.3-1.8 25.9.5 36.7 7.1 34.4 33.4 62.5 68.2 72.5 10.6 3.1 31.6 3.9 43 1.5 35.3-7.1 62.7-32.5 73.5-68 2.5-8.2 2.7-10.5 2.8-25 0-19.1-1.6-26.5-9.3-42-12.3-24.8-35.2-43.5-61.6-50.5-10.3-2.8-30-3.5-40.2-1.6zm27.9 64.2c5.5 1.8 12.9 8 16.2 13.7 3.6 6.2 5.1 15.1 3.7 21.9-5 24-33.1 33.6-52.3 17.8-2.1-1.8-5.1-5.9-7-9.8-2.9-5.8-3.3-7.6-3.2-14.2 0-9.5 2.7-15.9 9.2-22.3 9-8.8 20.2-11.2 33.4-7.1zM375.5 541.9c-8.7 2.2-16.6 8.3-21 16.2l-3 5.4v495l2.3 4.3c3.5 6.6 8.8 11.9 15 14.9l5.7 2.8h143l5-2.5c7.3-3.5 13.8-10.5 16.4-17.3l2.1-5.8V567.1l-2.1-5.6c-2.5-6.7-9.4-14.1-16.4-17.5l-5-2.5-69.5-.2c-38.2-.1-70.8.2-72.5.6zM478 811v206h-64V605h64v206zM629.4 541.9c-9.1 2.3-16.9 8.4-21.6 17.3l-2.3 4.3v495l2.3 4.3c3.5 6.6 8.8 11.9 15 14.9l5.7 2.8h142l6.7-3.3c7.2-3.5 12.4-8.8 15.5-15.8 1.7-3.6 1.8-12.3 2.3-133.9l.6-130 2.2-7.3c9.1-29.7 33.1-51.9 61.6-57.1 7.6-1.4 22.6-1.4 30.2 0 28.5 5.2 52.5 27.4 61.6 57.1l2.2 7.3.6 130c.5 121.6.6 130.3 2.3 133.9 3.1 7 8.3 12.3 15.5 15.8l6.7 3.3h142l5.7-2.8c6.2-3 11.5-8.3 15-14.9l2.3-4.3v-152c0-169.7.4-158.4-7.1-187.5-21.1-81-85.1-146.2-165.9-168.8-57.1-16-110.3-10.5-165.2 17.2-5.1 2.5-9.5 4.6-9.8 4.6-.3 0-.5-1.1-.5-2.5 0-4.1-3.8-13-7.5-17.3-2.2-2.5-6.3-5.4-10.3-7.4l-6.7-3.3-69-.2c-37.9 0-70.4.2-72.1.6zm102.8 80.3c.3 15.7.5 17.7 2.6 22 5.3 10.8 15 17 27.4 17.6 6.6.4 8.4 0 13.4-2.2 3.1-1.5 8.9-5.5 12.8-9 25-22.3 52.7-36.3 84.9-42.8 9.7-2 14.1-2.3 33.7-2.2 19.4 0 23.9.3 33 2.3 38.2 8.1 72.1 27.4 96.2 54.6 21.4 24.2 35.8 53.6 42 85.8 2.1 11 2.2 13.1 2.5 139.9l.4 128.8H1017V907.2c0-122.9.2-118.5-7.1-140.7-16.2-48.9-56.6-84.7-108.2-95.7-14.5-3.1-39.9-3.1-54.4 0-56.8 12.2-98.2 52.7-112.6 110.2-2.1 8.4-2.1 10.3-2.4 122.2l-.4 113.8H668V605h63.9l.3 17.2z"/></svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ContactFooter',

  props: {
    contactUrl: {
      type: String,
      required: true,
    },

    copyText: {
      type: String,
      required: true,
    },

    actionText: {
      type: String,
      required: true,
    },

    successText: {
      type: String,
      required: true,
    },

    tooltipDirection: {
      type: String,
      default: 'top',
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-footer {
  @include bottom-bar;
  justify-content: center;

  .contact-link {
    display: flex;
    align-items: center;
    margin: 0 .3em;
    padding: .5em 0;

    svg {
      display: inline-block;
      height: 1.5em;
      width: auto;
      margin-left: .3em;
      color: $secondary;
      vertical-align: middle;
    }

    &:focus {
      svg {
        border-radius: 50%;
        box-shadow: 0 .2em .6em lighten($secondary, 10%);
      }
    }

    &:focus, &:hover {
      svg {
        color: lighten($secondary, 10%);
      }
    }
  }
}
</style>
